// app/javascript/controllers/file_input_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["input", "text"]

    connect() {
        // console.log("FileInputController connected");
        this.inputTarget.addEventListener('change', () => {
            this.updateText();
        });
    }

    // click() {
    //     console.log("Button clicked");
    //     this.inputTarget.click();
    // }

    updateText() {
        var files = this.inputTarget.files;
        var label = files.length > 1 ? files.length + ' files selected' : files[0].name;
        this.textTarget.value = label;
    }
}
